'use strict';

var dynamicColors = require('../config/dynamic-colors.json');
var _ = require('lodash');
var PaxGridDataProviderService = function PaxGridDataProviderService($q, configurationService, dataRetrieverService, constantsService, optWeekService) {
  var colorMap = configurationService.getROMColorConfiguration();
  function getData(gridId) {
    if (gridId) {
      if (gridId === 'loco-fare-heatmap') {
        return dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_LOCO_MODE).retrieveComponentData(gridId);
      } else if (gridId === 'service-opportunities') {
        return dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_FLATTENED_SERVICES_MODE).retrieveComponentData(gridId);
      } else {
        return dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_FLATTENED_SERVICES_MODE).localSortApplied().retrieveComponentData(gridId);
      }
    }
  }
  function getFilters(gridId) {
    if (gridId) {
      if (gridId === 'loco-fare-heatmap') {
        return dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_LOCO_MODE).brushFilters();
      } else if (gridId === 'service-opportunities') {
        return dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_FLATTENED_SERVICES_MODE).brushFilters();
      } else {
        return dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_FLATTENED_SERVICES_MODE).localSortApplied().brushFilters();
      }
    }
  }
  function getColorConfiguration(type) {
    return colorMap[type];
  }
  function getRangeOfValues(data) {
    var min, max;
    var adjustMinMax = function adjustMinMax(cell) {
      if (_.isNumber(cell)) {
        min = _.min([min, cell]);
        max = _.max([max, cell]);
      }
    };
    _.forEach(data, function (row) {
      _.each(row, adjustMinMax);
    });
    min = Math.floor(min);
    max = Math.ceil(max);
    return {
      min: min,
      max: max
    };
  }
  function getDynamicColorMap(gridId, data) {
    var range, bucketSize;
    var colors = dynamicColors[gridId];
    range = getRangeOfValues(data);
    bucketSize = (range.max - range.min) / colors.length;
    return colors.map(function (color, i) {
      var mappedColor = {
        start: range.min + i * bucketSize,
        end: range.min + (i + 1) * bucketSize
      };
      _.assign(mappedColor, color);
      return mappedColor;
    });
  }
  function generateRTPRanges() {
    var rtpRanges = configurationService.getParsedRTPS();
    var columns = [];
    for (var i = 0, l = rtpRanges.length; i < l; i++) {
      columns.push({
        field: 'range' + i,
        label: rtpRanges[i]
      });
    }
    return columns;
  }
  function generateRelevantDaysOfWeek() {
    var daysOfWeek = optWeekService.getDaysOfWeek();
    return daysOfWeek.map(function (item) {
      item = item.toUpperCase();
      return {
        label: item,
        field: item
      };
    });
  }
  return {
    getData: getData,
    getFilters: getFilters,
    getColorConfiguration: getColorConfiguration,
    getDynamicColorMap: getDynamicColorMap,
    generateRTPRanges: generateRTPRanges,
    generateRelevantDaysOfWeek: generateRelevantDaysOfWeek
  };
};
PaxGridDataProviderService.$inject = ['$q', 'ConfigurationService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'OptWeekService'];
module.exports = PaxGridDataProviderService;